/**
 * Barra de navegacao inferior para dispositivos moveis (Bottom Tabs).
 *
 * Permite alternar instantaneamente entre a visao cartografica desobstruida,
 * a gaveta de indicacoes e a sintese estatistica contextual.
 *
 * @module components/MobileBottomNav
 */

export default function MobileBottomNav({
  activeTab, // "mapa" | "indicacoes" | "resumo"
  onSelectTab,
  indicacoesCount = 0,
  hasSelected = false,
  autorFilter = null,
}) {
  const resumoLabel = autorFilter ? "Vereador" : "Resumo";

  return (
    <nav
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        height: 56,
        background: "var(--bg-glass)",
        backdropFilter: "blur(18px)",
        WebkitBackdropFilter: "blur(18px)",
        borderTop: "1px solid var(--border-color)",
        display: "flex",
        alignItems: "stretch",
        zIndex: 1050,
        boxShadow: "0 -4px 16px rgba(0, 0, 0, 0.08)",
        userSelect: "none",
      }}
      aria-label="Navegação móvel"
    >
      {/* ── Aba 1: Mapa ── */}
      <button
        type="button"
        onClick={() => onSelectTab("mapa")}
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 3,
          background: "transparent",
          border: "none",
          cursor: "pointer",
          color: activeTab === "mapa" ? "var(--accent-primary)" : "var(--text-muted)",
          transition: "all var(--transition-fast)",
          padding: "6px 0",
        }}
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={activeTab === "mapa" ? "2.4" : "1.8"}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21" />
          <line x1="9" y1="3" x2="9" y2="18" />
          <line x1="15" y1="6" x2="15" y2="21" />
        </svg>
        <span
          style={{
            fontSize: "var(--text-micro)",
            fontWeight: activeTab === "mapa" ? 700 : 500,
          }}
        >
          Mapa
        </span>
      </button>

      {/* ── Aba 2: Indicações ── */}
      <button
        type="button"
        onClick={() => onSelectTab("indicacoes")}
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 3,
          background: "transparent",
          border: "none",
          cursor: "pointer",
          color: activeTab === "indicacoes" ? "var(--accent-primary)" : "var(--text-muted)",
          transition: "all var(--transition-fast)",
          padding: "6px 0",
          position: "relative",
        }}
      >
        <div style={{ position: "relative", display: "inline-flex" }}>
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={activeTab === "indicacoes" ? "2.4" : "1.8"}
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
            <line x1="16" y1="13" x2="8" y2="13" />
            <line x1="16" y1="17" x2="8" y2="17" />
            <polyline points="10 9 9 9 8 9" />
          </svg>
          {indicacoesCount > 0 && (
            <span
              style={{
                position: "absolute",
                top: -3,
                right: -8,
                background: "var(--accent-primary)",
                color: "#ffffff",
                fontSize: "var(--text-micro)",
                fontWeight: 800,
                borderRadius: "var(--radius-full)",
                padding: "0 4px",
                lineHeight: "14px",
                height: 14,
              }}
            >
              {indicacoesCount > 999 ? "999+" : indicacoesCount}
            </span>
          )}
        </div>
        <span
          style={{
            fontSize: "var(--text-micro)",
            fontWeight: activeTab === "indicacoes" ? 700 : 500,
          }}
        >
          Indicações
        </span>
      </button>

      {/* ── Aba 3: Resumo / Detalhes / Vereador ── */}
      <button
        type="button"
        onClick={() => onSelectTab("resumo")}
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 3,
          background: "transparent",
          border: "none",
          cursor: "pointer",
          color: activeTab === "resumo" ? "var(--accent-primary)" : "var(--text-muted)",
          transition: "all var(--transition-fast)",
          padding: "6px 0",
        }}
      >
        {autorFilter ? (
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={activeTab === "resumo" ? "2.4" : "1.8"}
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
          </svg>
        ) : (
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={activeTab === "resumo" ? "2.4" : "1.8"}
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="20" x2="18" y2="10" />
            <line x1="12" y1="20" x2="12" y2="4" />
            <line x1="6" y1="20" x2="6" y2="14" />
          </svg>
        )}
        <span
          style={{
            fontSize: "var(--text-micro)",
            fontWeight: activeTab === "resumo" ? 700 : 500,
          }}
        >
          {resumoLabel}
        </span>
      </button>
    </nav>
  );
}
